<template>
    <main-content with_go_back_bar>
        <template slot="action_bar">
            <router-link class="btn btn-success mx-2"
                         to="/shareholder/create"
                         v-text="$t('label.create_shareholder')"
            ></router-link>
        </template>
        <kt-datatable v-bind="datatableProps" ref="datatable">
        </kt-datatable>
    </main-content>
</template>

<script>
    import mainContent from "@/components/main-content";
    import {ApiUrl} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import columns from "./components/columns";
    import actions from "./components/actions";

    export default {
        components: {
            mainContent,
        },
        data() {
            return {
                query: {},
            };
        },
        methods: {
            filterAction(e, query) {
                this.query = query;

                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
            },
        },
        computed: {
            datatableProps() {
                return {
                    id: "shareholders_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: this.$can('manage-stakeholder', 'user') ? ApiUrl.path('shareholder/admin/paginate') : ApiUrl.path('shareholder/paginate'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actions,
                }
            },
        },
    }
</script>
